import React, { Component } from 'react'
import _ from 'lodash'

import Repository from '../felles/repository'
import Loading from '../felles/loading'
import ArbeidslisteAktiv from './arbeidsliste-aktiv'
import { resolve } from '../dependencies'
import {Maalerstatus} from '../felles/utils/statuskoder'

export default class ArbeidslisteAktivContainer extends Component {

    constructor() {
        super()

        this.state = {
            vannmaalere: [],
            tittel: '',
            beskrivelse: '',
            laster: false
        }

        this._hentArbeidsliste = this._hentArbeidsliste.bind(this)
        this._onDataMotatt = this._onDataMotatt.bind(this)
        this._hentOgOppdaterSmsData = this._hentOgOppdaterSmsData.bind(this)
        this._oppdaterSmsData = this._oppdaterSmsData.bind(this)
    }

    componentDidMount() {
        this._isMounted = true
        this.setState({
            laster: true
        })
        this._hentArbeidsliste().then(this._onDataMotatt)
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    _hentArbeidsliste() {
        return resolve(Repository).hentArbeidslisteMedId(this.props.match.params.ListeId)
    }

    _onDataMotatt(liste) {
        let arbliste = liste

        let alleMaalere = []
        
        _.map(liste.VannmaalerePlanlegging, function (maaler) {
            if (maaler.Status < Maalerstatus.Skiftet)
                alleMaalere.push(maaler)
        })
        
        alleMaalere = _.orderBy(alleMaalere,"Avtaltdato")
        _.map(liste.VannmaalerePlanlegging, function (maaler) {
            if (maaler.Status === Maalerstatus.Skiftet || maaler.Status === Maalerstatus.IkkeSkiftet)
                alleMaalere.push(maaler)
        })

        this.setState({
            vannmaalere: alleMaalere,
            tittel: arbliste.Tittel,
            beskrivelse: arbliste.Beskrivelse,
            id: arbliste.Id,
            laster: false
        }, () => {
            // SMS-svar ("ok"/"ja" => Avtalt) beregnes på read-time og lagres ikke i basen.
            // Etter at SMS-lastingen ble gjort asynkron (PR 115010) sluttet Arbeidslister/{id}
            // å berike status med SMS-svar, så feltbildet (utskiftning) viste kun rå DB-status.
            // Vi henter SMS-data på samme måte som planlegging og fletter inn statusen etterpå.
            this._hentOgOppdaterSmsData(arbliste.Id)
        })
    }

    _hentOgOppdaterSmsData(listeId) {
        resolve(Repository)
            .hentSmsForArbeidsliste(listeId)
            .then(this._oppdaterSmsData)
            .catch(() => { /* SMS-status er sekundær – feltlisten vises uansett */ })
    }

    _oppdaterSmsData(smsData) {
        // Unngå setState etter at komponenten er avmontert (bruker navigerte vekk før
        // SMS-svaret rakk å komme tilbake) – ellers en React-advarsel om unmounted component.
        if (!this._isMounted) return
        if (!smsData || !smsData.length) return

        // SMS-svar kan ikke flytte en måler over Skiftet-grensen (status settes kun til
        // Varslet(1)/Avtalt(2)), så bøtte-inndelingen i _onDataMotatt er fortsatt gyldig –
        // vi oppdaterer derfor status in-place uten å sortere på nytt.
        const oppdaterteVannmaalere = this.state.vannmaalere.map(maaler => {
            const sms = smsData.find(s => s.MaalerId === maaler.MaalerId)
            if (!sms) return maaler
            return Object.assign({}, maaler, {
                SmsStatus: sms.SmsStatus,
                SmsLevertStatus: sms.SmsLevertStatus,
                Mobil: sms.Mobil || maaler.Mobil,
                Status: sms.Status
            })
        })
        this.setState({ vannmaalere: oppdaterteVannmaalere })
    }

    render() {
        return (
            <div>
                {
                    this.state.laster ?
                        <Loading tekst="Henter arbeidsliste" />
                        :
                        <ArbeidslisteAktiv tittel={this.state.tittel} beskrivelse={this.state.beskrivelse} id={this.state.id}
                            vannmaalere={this.state.vannmaalere} match={this.props.match} history={this.props.history} />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/utskiftning/arbeidsliste-aktiv-container.jsx